<script>
import { toasted, toast } from '@/js/utils.js'
import debounce from 'lodash/debounce'

export default {
  methods: {
    setupSocketIOCommonEvents (socket) {
      const self = this // eslint-disable-line no-unused-vars
      socket.on('generic-toast', (json) => {
        console.log(`Server sent generic toast to socket: window.${socket.id}`)
        toast(json.msg, json.duration, json.cls)
      })

      socket.on(`self-control-in-admin-room`, debounce(async () => {
        // not checking for event rooms since
        // we want to show this even in event rooms
        this.$store.dispatch('addSystemMessage', {
          msg: `Use sync button to sync back`,
          selfHash: this.userProfile.userHash
        })
      }, 5000, { leading: true, trailing: false }))

      socket.on('refresh-pending-requests', async (data = {}) => {
        const { nickname, emailHash } = data
        if (!nickname || !emailHash) {
          return
        }
        const { $store: { getters: { roomProperties } } } = this
        if (roomProperties && roomProperties.isEvent) {
          // Don't show notifications in an event room
          return
        }
        toasted(`${nickname} would like to add you as a friend`, {
          duration: 30000,
          action: [
            {
              text: 'Accept',
              onClick: (e, toastObject) => {
                socket.emit('accept-request', emailHash, () => toastObject.goAway(0))
              }
            },
            {
              text: 'Reject',
              onClick: (e, toastObject) => {
                socket.emit('reject-request', emailHash, () => toastObject.goAway(0))
              }
            }
          ]
        }, self)
      })

      socket.on('app-status', this.updateAppStatus)
    },
    updateAppStatus (status) {
      this.$store.commit('appStatus', status)
    },
    handleBanOrKick (reason) {
      this.$router.push({
        path: '/home'
      })
      let message
      switch (reason) {
        case 'banned':
        case 'kicked':
          message = `You've been ${reason} from the room.`
          break
        case 'owner-limit':
          message = `Maximum number of owned rooms reached. Use a room you already own or delete one.`
          break
        case 'room-destroy':
          message = `The owner deleted the room.`
          break
      }
      toasted(message, {
        duration: 10000,
        action: [
          {
            text: 'Close',
            onClick: (e, toastObject) => {
              toastObject.goAway(0)
            }
          }
        ]
      }, this)
    },
    getRoomUsers (socket) {
      return new Promise(resolve => {
        this.socket.emit('get-room-users', null, function (data) {
          resolve(data)
        })
      })
    },
    async updateRoomUsersState (data) {
      if (!data) {
        return
      }
      const { roomUsers: newRoomUsers, peerMap } = data
      const { roomUsers } = this.$store.getters

      await Promise.all(Object.entries(newRoomUsers).map(async ([hash, props]) => {
        if (!roomUsers[hash]) {
          this.$set(roomUsers, hash, props)
          const avatar = await this.$store.dispatch('fetchAvatar', hash)
          this.$set(roomUsers[hash], 'avatar', avatar)
        } else {
          const user = roomUsers[hash]
          for (const [k, v] of Object.entries(props)) {
            this.$set(user, k, v)
          }
        }
      }))

      if (peerMap) {
        this.$store.commit('activeRoomUsers', peerMap)
        await this.$store.dispatch('updateRemoteWebcamStreams', peerMap)
      }
    },
    initializeView () {
    }
  }
}
</script>
